
import { Button } from "@/components/ui/button";
import { Copy } from "lucide-react";

interface ReferralLinkCopyProps {
  referralLink: string;
  copyReferralLink: () => void;
}

const ReferralLinkCopy = ({ referralLink, copyReferralLink }: ReferralLinkCopyProps) => {
  return (
    <div className="bg-blue-50 border border-blue-100 rounded-lg p-4 mb-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
        <div className="w-full sm:w-auto overflow-hidden">
          <div className="text-sm font-medium text-[#4A5568] mb-1">Your referral link:</div>
          <div className="text-sm bg-white border border-gray-200 rounded-md px-3 py-2 truncate">
            {referralLink}
          </div>
        </div>
        <Button 
          onClick={copyReferralLink}
          className="bg-[#517FA4] hover:bg-[#406584] w-full sm:w-auto"
        >
          <Copy className="h-4 w-4 mr-2" />
          Copy Link
        </Button>
      </div>
    </div>
  );
};

export default ReferralLinkCopy;
